import { doc, setDoc } from "firebase/firestore";
import { db } from "firebaseApp";

export const getTalkId = (uid1, uid2) => {
  if(uid1 <= uid2) return `${uid1}-${uid2}`;
  return `${uid2}-${uid1}`;
}

export const createTalk = async (uid1, uid2) => {
  try {
    const talkId = getTalkId();
    await setDoc(doc(db, "talks", talkId), {
      uid1,
      uid2,
      createdAt: new Date().getTime(),
    });
    return {
      success: true,
      talkId,
    }
  } catch(error) {
    return {
      success: false,
    }
  }
}